<template>
  <svg class="basis-svg-icon" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'BasisSvgIcon',
  props: {
    name: {
      type: String,
      default: 'icon-xxx'
    }
  },
  computed: {
    iconName () {
      return `#${this.name}`
    }
  }
}
</script>

<style lang="scss" scoped>
.basis-svg-icon {
  width: 1em; height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
